// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoBlock_root__-gSmN","title":"InfoBlock_title__1onaI"};